import { render, staticRenderFns } from "./TopIndividualProgramRankings.vue?vue&type=template&id=5a55f3db&scoped=true&"
import script from "./TopIndividualProgramRankings.vue?vue&type=script&lang=js&"
export * from "./TopIndividualProgramRankings.vue?vue&type=script&lang=js&"
import style0 from "./TopIndividualProgramRankings.vue?vue&type=style&index=0&id=5a55f3db&lang=less&scoped=true&"
import style1 from "./TopIndividualProgramRankings.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55f3db",
  null
  
)

export default component.exports